module.exports = __webpack_public_path__ + "media/damages/szkoda@3x-ae301845.svg";